var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warning",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 174.151,
    height: 155.624,
    viewBox: "0 0 174.151 155.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 174.151,
    height: 155.624,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M87.075,8.5c-3.387,0-6.774,2.284-9.344,6.852L10.655,130.513c-5.139,9.136-.767,16.611,9.715,16.611H153.781c10.482,0,14.854-7.475,9.715-16.611L96.419,15.352C93.85,10.784,90.463,8.5,87.076,8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M87.075,0c6.649,0,12.755,4.077,16.753,11.185l67.013,115.049c4.032,7.166,4.371,14.525.993,20.3s-9.958,9.088-18.053,9.088H20.37c-8.095,0-14.675-3.313-18.053-9.088s-3.039-13.135.929-20.19L70.386,11.074C74.322,4.076,80.428,0,87.075,0Zm66.706,138.624c2.219,0,3.236-.538,3.418-.727a7.007,7.007,0,0,0-1.111-3.217L89.074,19.63a7.876,7.876,0,0,0-2-2.529,7.477,7.477,0,0,0-1.936,2.419L18,134.791a5.464,5.464,0,0,0-.979,3.224,7.007,7.007,0,0,0,3.349.608Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M87.075,22.738l65.854,112.723H21.222L87.076,22.738Z",
    fill: "#f6c22d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M87.075,102.738c-3.38,0-6.327-1.833-6.6-5.6L78.24,62.92c-.537-7.475,3.414-11.014,8.839-11.011S96.447,55.45,95.91,62.92L93.677,97.136C93.4,100.9,90.455,102.738,87.075,102.738Z",
    fill: "#222223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M87.075,22.738l65.854,112.723H21.222L87.076,22.738Zm0-14.238c-3.387,0-6.774,2.284-9.344,6.852L10.655,130.513c-5.139,9.136-.767,16.611,9.715,16.611H153.781c10.482,0,14.854-7.475,9.715-16.611L96.419,15.352C93.85,10.784,90.463,8.5,87.076,8.5Z",
    fill: "#222223"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 8.662,
    cy: 8.662,
    r: 8.662,
    transform: "translate(78.413 107.329)",
    fill: "#222223"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.482536495b3887233061658c2b6e7aba.svg";
export { ForwardRef as ReactComponent };